import { render, staticRenderFns } from "./closeReturnStep.vue?vue&type=template&id=0b350b7b&scoped=true&"
import script from "./closeReturnStep.vue?vue&type=script&lang=ts&"
export * from "./closeReturnStep.vue?vue&type=script&lang=ts&"
import style0 from "./closeReturnStep.vue?vue&type=style&index=0&id=0b350b7b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b350b7b",
  null
  
)

export default component.exports